/**
 * The app's store listings, and which one a web visitor's phone wants.
 * One home for the URLs the download banner and the Pilot install offer share.
 */
export const APP_STORE_URL = "https://apps.apple.com/app/id6766032580";
export const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=com.trybeup.app";

export type WebDevice = "ios" | "android" | "desktop";

/** iPhone/iPad (iPadOS 13+ reports as a touch Mac), Android, or anything else. */
export function webDeviceFor(ua: string | null | undefined, hasTouch = false): WebDevice {
  const s = ua || "";
  if (/iPhone|iPad|iPod/.test(s) || (/Macintosh/.test(s) && hasTouch)) return "ios";
  if (/Android/i.test(s)) return "android";
  return "desktop";
}

/** This browser's device. */
export function currentWebDevice(): WebDevice {
  if (typeof navigator === "undefined") return "desktop";
  const touch = typeof document !== "undefined" && "ontouchend" in document;
  return webDeviceFor(navigator.userAgent, touch);
}

/** The one store link for a phone; null on a desktop (show both). */
export function storeUrlFor(device: WebDevice): string | null {
  if (device === "ios") return APP_STORE_URL;
  if (device === "android") return GOOGLE_PLAY_URL;
  return null;
}
